import { makeStyles } from 'tss-react/mui';
import { grey } from '@mui/material/colors';
import { ClassNameMap } from '@mui/material';


export const useProviderItemMobileLayout = makeStyles<{ classes?: Partial<ClassNameMap<'root'>> }>()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    borderTop: `1px solid ${theme.palette.divider}`,
    '&:last-of-type': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    padding: theme.spacing(3, 2),
    '&:active': {
      background: grey[50],
    },
  },
  bio: {
    fontSize: '18px',
    lineHeight: '1.5',

    // line clamping
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
  },
  specialties: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'pre-line',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
}));


export const useProviderItemDesktopLayout = makeStyles<{ classes?: Partial<ClassNameMap<'root'>> }>()(theme => ({
  root: {
    display: 'flex',
    gap: theme.spacing(3),
    padding: theme.spacing(3),
    borderTop: `1px solid ${theme.palette.divider}`,
    border: `1px solid ${theme.palette.divider}`,
    '&:last-of-type': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
    '&:not(:first-of-type)': {
      marginTop: theme.spacing(4),
    },
    maxHeight: '294px',
    transition: theme.transitions.create('box-shadow', { duration: 200 }),
    '&:hover': {
      cursor: 'pointer',
      boxShadow: theme.shadows[3],
    },
    '&:active': {
      background: grey[50],
    },
  },
  bio: {
    fontSize: '18px',
    lineHeight: '1.5',

    // line clamping
    display: '-webkit-box',
    overflow: 'hidden',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 4,
  },
  specialties: {
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    whiteSpace: 'pre-line',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
}));
